module.exports = __webpack_public_path__ + "img/youtubeMusic.4c33ae8a.svg";